<template>
    <div class="bodymain">
        
        <Content/>
        <Footer/>
    </div>    
</template>

<script>

import Content from '../general/Content'
import Footer from '../general/Footer'


export default {
    name: 'BodyM',
    components:{
        Content,
        Footer
    }
}
</script>

<style>
     body{
    background-color: #ffffff;
    overflow-x: hidden;
    margin: 0;
    padding: 0;
    
        background-image: url('../../assets/wall.png');
        
        background-size: contain;
        
    
  }

@media screen and (max-width:768px){
    body{
        overflow-x: hidden;
    }
}

</style>